import { useQueryClubFeatureFlagsAsPublic } from "@gymflow/api";
import { UserMemberBean } from "@gymflow/types";

import { useClubSettings } from "../../providers";
import useGymflowModels from "../../store";
import { SideBarUserFormNew } from "./SideBarUserFormNew";
import { SideBarUserFormOld } from "./SideBarUserFormOld";

export type SideBarUserFormProps = {
  className?: string;
  hide: () => void;
  onMemberCreated: (newUserId: string) => void;
  onChange: (newValue: any) => void;
  defaultValues: any;
  requiredFields: any;
  userBeforeUpdate?: UserMemberBean;
};

export const SideBarUserForm = (props: SideBarUserFormProps) => {
  const settings = useClubSettings();
  const { api } = useGymflowModels();
  const { data: featureFlags } = useQueryClubFeatureFlagsAsPublic({
    api,
    clubId: settings.clubId,
  });
  if (featureFlags?.featureFlags.ONBOARDING_FLOW) {
    return (
      <SideBarUserFormNew
        {...props}
        defaultValues={{
          email: props.defaultValues.email,
          firstName: props.defaultValues["first-name"],
          lastName: props.defaultValues["last-name"],
          mobileNumber: props.defaultValues["mobile-number"],
        }}
      />
    );
  } else {
    return <SideBarUserFormOld {...props} />;
  }
};
